import { Route, Routes } from "react-router-dom";
import { SectionMain } from "../../../../generic/Layouts/OrderlikeLayout";
import LikutModalsProvider from "./modalsForLikut/LikutModalsProvider";
import LikutExpressPalletSection from "./palletSection/LikutExpressPalletSection";
import LikutListView from "./Components/LikutListView";
import { LINKS, relPath } from "../../../../Routs/config";
import useLikutExpressList from "./services/hooks/useLikutExpressList";

export default function LikutExpress() {
    const {
        azmanotList,
        inputAzmanotSearch,
        searchAzmana,
        sortedByRamp,
        sortByRamp,
        setSelectedDateStart,
        tranzitID,
        handleSelectTransit,
        warehouseList,
        azmanaNum,
        setAzmanaNum,
        palletList,
        checkForActiveLikutAzmana,
        handleFetchOrders,
        isNeedToSortByKav,
        isDev,
        isAddIdToDesc,
        clientList,
        handleOpenDefaults,
    } = useLikutExpressList()

    return (
        <SectionMain>
            <LikutModalsProvider>
                <Routes>
                    <Route index element={
                        <LikutListView
                            azmanotList={azmanotList}
                            inputAzmanotSearch={inputAzmanotSearch}
                            searchAzmana={searchAzmana}
                            sortedByRamp={sortedByRamp}
                            sortByRamp={sortByRamp}
                            setSelectedDateStart={setSelectedDateStart}
                            tranzitID={tranzitID}
                            handleSelectTransit={handleSelectTransit}
                            warehouseList={warehouseList}
                            isNeedToSortByKav={isNeedToSortByKav}
                            isDev={isDev}
                            handleOpenDefaults={handleOpenDefaults}
                            setAzmanaNum={setAzmanaNum}
                            checkForActiveLikutAzmana={checkForActiveLikutAzmana}
                            clientList={clientList}
                            isAddIdToDesc={isAddIdToDesc}
                        />
                    }/>
                    <Route path={`${relPath(LINKS.likut.likutExperess.palletSection, LINKS.likut.likutExperess.mainUrl)}/*`} element={
                        <LikutExpressPalletSection
                            azmanaNum={azmanaNum}
                            palletList={palletList}
                            handleFetchOrders={handleFetchOrders}
                        />}
                    />
                </Routes>
            </LikutModalsProvider>
        </SectionMain>
    )
}
